// extracted by mini-css-extract-plugin
export default {"popup-title":"BillingNotSentTotalsPopup_popup-title_l_jJF"};